import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import financialReducer from '../features/financial/financialSlice';
import uiReducer from '../features/ui/uiSlice';

const appReducer = combineReducers({
  auth: authReducer,
  financial: financialReducer,
  ui: uiReducer,
});

const rootReducer = (state, action) => {
  // Reset all state when RESET_APP action is dispatched
  if (action.type === 'RESET_APP') {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;